import { render, staticRenderFns } from "./PDFViewerExtended.vue?vue&type=template&id=10b88ae5"
import script from "./PDFViewerExtended.vue?vue&type=script&lang=js"
export * from "./PDFViewerExtended.vue?vue&type=script&lang=js"
import style0 from "./PDFViewerExtended.vue?vue&type=style&index=0&id=10b88ae5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports